export const ProductionSimulation = (json: IProductionSimulation): IProductionSimulationModel => {
	const {
		created_at,
		updated_at,
		current_step,
		production_plan_id,
		finalized_at,
		needs_rebuild,
		synchronization_status,
		...rest
	} = json

	return {
		...rest,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
		currentStep: current_step,
		productionPlanID: production_plan_id,
		finalizedAt: finalized_at ? new Date(finalized_at) : null,
		needsRebuild: needs_rebuild,
		synchronizationStatus: synchronization_status ?? null,
	}
}

export const ProductionSimulationReplenishment = (
	json: IProductionSimulationReplenishment,
): IProductionSimulationReplenishmentModel => {
	const {
		crm_raw_material_id,
		id,
		mechanical_processing_coefficient,
		name,
		thermal_processing_coefficient,
		unit,
		...rest
	} = json

	return {
		...rest,
		crmRawMaterialID: crm_raw_material_id,
		id,
		mechanicalProcessingCoefficient: mechanical_processing_coefficient,
		name,
		thermalProcessingCoefficient: thermal_processing_coefficient,
		unit,
	}
}

export const ProductionSimulationReplenishmentRequestToJson = (
	json: IProductionSimulationReplenishmentRequestModel,
): IProductionSimulationReplenishmentRequest => {
	const { positionId, date, productId, quantity, ...rest } = json

	return {
		...rest,
		position_id: positionId,
		date,
		product_id: productId,
		quantity,
	}
}
